import { IAcl } from '@app/interfaces/acl';

const groupIds: string[] = [];

export const defaultAcl: IAcl = {
  modules: [
    {
      name: 'fishven-admin-tool',
      features: [
        {
          name: 'dashboardHomeView',
          views: [],
          visible: true,
          isIndex: true,
          permission: {
            create: null,
            edit: null,
            delete: null,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'profile',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: false,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'licenseTypes',
          views: [
            {
              name: 'tableView',
              visible: true,
              subViews: [],
              isIndex: false,
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'adminUsers',
          views: [
            {
              name: 'tableView',
              visible: true,
              subViews: [],
              isIndex: false,
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'licenses',
          views: [
            {
              name: 'actions',
              visible: true,
              isIndex: false,
              subViews: [
                {
                  name: 'printLicense',
                  visible: true,
                  subViews: [],
                  isIndex: false,
                },
                {
                  name: 'printBvr',
                  visible: true,
                  subViews: [],
                  isIndex: false,
                },
                {
                  name: 'licensePrinted',
                  visible: true,
                  subViews: [],
                  isIndex: false,
                },
                {
                  name: 'licenseFormalVerified',
                  visible: true,
                  subViews: [],
                  isIndex: false,
                },
              ],
            },
            {
              name: 'tableView',
              visible: true,
              subViews: [
                {
                  name: 'bulkImport',
                  visible: true,
                  subViews: [],
                },
                {
                  name: 'generatedLicensesDailySalesDownload',
                  visible: true,
                  subViews: [],
                },
                {
                  name: 'generatedLicensesFullListDownload',
                  visible: true,
                  subViews: [],
                },
                {
                  name: 'generatedLicensesMonthlyJournalDownload',
                  visible: true,
                  subViews: [],
                },
                {
                  name: 'generatedLicensesOverviewValidatedDownload',
                  visible: true,
                  subViews: [],
                },
                {
                  name: 'generatedLicensesSummaryByDay',
                  visible: true,
                  subViews: [],
                },
                {
                  name: 'generatedLicensesWebshopSalesDownload',
                  visible: true,
                  subViews: [],
                },
                {
                  name: 'generatedLicensesYearlyJournalDownload',
                  visible: true,
                  subViews: [],
                },
              ],
              isIndex: false,
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            cancel: true,
            view: true,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'licensesReturn',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'fishers',
          views: [
            {
              name: 'tableView',
              visible: true,
              subViews: [
                {
                  name: 'softDeletedFilter',
                  visible: true,
                  subViews: [],
                },
              ],
              isIndex: false,
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            archive: true,
            cancel: false,
            download: true,
            view: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'sessions',
          views: [
            {
              name: 'tableView',
              visible: true,
              isIndex: false,
              subViews: [],
            },
            {
              name: 'sessionView',
              visible: true,
              isIndex: false,
              subViews: [],
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            download: true,
            view: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'catches',
          views: [
            {
              name: 'tableView',
              visible: true,
              isIndex: false,
              subViews: [],
            },
            {
              name: 'catchView',
              visible: true,
              isIndex: false,
              subViews: [],
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            download: true,
            view: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'inspections',
          views: [
            {
              name: 'tableView',
              visible: true,
              isIndex: false,
              subViews: [
                {
                  name: 'yearlySummary',
                  visible: true,
                  subViews: [],
                },
              ],
            },
            {
              name: 'invoiceDetails',
              visible: null,
              isIndex: null,
              subViews: [
                {
                  name: 'sendInvoice',
                  visible: true,
                  subViews: [],
                },
              ],
            },
            {
              name: 'inspectionView',
              visible: true,
              isIndex: false,
              subViews: [],
            },
            {
              name: 'penaltyView',
              visible: true,
              isIndex: false,
              subViews: [
                {
                  name: 'cancelPenalty',
                  visible: true,
                  subViews: [],
                },
                {
                  name: 'penaltyAssessment',
                  visible: true,
                  subViews: [],
                },
                {
                  name: 'editPenalty',
                  visible: true,
                  subViews: [],
                },
              ],
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: null,
            delete: true,
            download: true,
          },
          groupIds: groupIds,
          history: [],
        },
        {
          name: 'paperStatistics',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'inventory',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'naturalBreeding',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'stocking-plan',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'stocking-journal',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'stocking-yearly-summary',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'breedingJournal',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'fishMovement',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'observations',
          views: [
            {
              name: 'tableView',
              visible: true,
              isIndex: false,
              subViews: [
                {
                  name: 'yearlySummary',
                  visible: true,
                  subViews: [],
                },
              ],
            },
            {
              name: 'observationView',
              visible: true,
              isIndex: false,
              subViews: [
                {
                  name: 'date',
                  visible: null,
                  subViews: [],
                },
                {
                  name: 'waterbody',
                  visible: null,
                  subViews: [],
                },
                {
                  name: 'inspector',
                  visible: null,
                  subViews: [],
                },
                {
                  name: 'category',
                  visible: null,
                  subViews: [],
                },
                {
                  name: 'description',
                  visible: null,
                  subViews: [],
                },
                {
                  name: 'images',
                  visible: null,
                  subViews: [],
                },
                {
                  name: 'location',
                  visible: null,
                  subViews: [],
                },
              ],
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            download: true,
          },
          groupIds: groupIds,
          history: [],
        },
        {
          name: 'draughtiness',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'waterQuality',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'professionalFishers',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'huntersKills',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'hunters',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'kills',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'huntingInspections',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'analyticsFishingOperations',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'analyticsFishingManagement',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'analyticsFishingHabitat',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'analyticsProfessionalFishers',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'analyticsHuntingOperations',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'analyticsSummary',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'analyticsBasicStatistics',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'members',
          views: [
            {
              name: 'tableView',
              visible: true,
              isIndex: false,
              subViews: [],
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            download: true,
          },
          groupIds: groupIds,
        },

        {
          name: 'userDetails',
          views: [
            {
              name: 'tableView',
              visible: true,
              isIndex: false,
              subViews: [],
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'roles',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'organisationalUnits',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'waterbodies',
          views: [
            {
              name: 'tableView',
              visible: true,
              isIndex: false,
              subViews: [],
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'waterbodyRegulations',
          views: [
            {
              name: 'tableView',
              visible: true,
              isIndex: false,
              subViews: [],
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'geographicAreas',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'fishTypes',
          views: [
            {
              name: 'tableView',
              visible: true,
              isIndex: false,
              subViews: [],
            },
          ],
          visible: true,
          isIndex: false,
          permission: {
            create: true,
            edit: true,
            delete: true,
            download: true,
          },
          groupIds: groupIds,
        },
        {
          name: 'netTypes',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'reports',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'generalSettings',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
        {
          name: 'workflowsSettings',
          views: [],
          visible: true,
          isIndex: false,
          permission: {
            create: null,
            edit: null,
            delete: null,
          },
          groupIds: groupIds,
        },
      ],
      visible: null,
      history: [],
      permission: null,
    },
  ],
};
